export default {
  locale: "es",
  name: "Servicios",
  translation: { displayName: "Traducciones" },
  fields: {
    list: [],
    form: [],
  },
};
